import React from 'react';
import PropTypes from 'prop-types';
import styles from './answerKeys.scss';
import UIConstants from '../../constants/UIConstants';

const QuestionAnswerKeys = (props) => {
    const {
        isMatchingQuestion,
        answerKeys,
        itemIndex,
    } = props;

    if (isMatchingQuestion && answerKeys[itemIndex]) {
        return answerKeys[itemIndex];
    }

    return answerKeys.map((answerKey) => {
        const className = answerKey === UIConstants.ANSWER_KEYS.ANY_ORDER ? styles.descriptor : undefined;
        return <div key={answerKey} className={className}>{answerKey}</div>;
    });
};

QuestionAnswerKeys.propTypes = {
    isMatchingQuestion: PropTypes.bool.isRequired,
    answerKeys: PropTypes.array.isRequired,
    itemIndex: PropTypes.number.isRequired,
};

export default QuestionAnswerKeys;

